import { useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
const BARCODE_VALID_LENGTHS = [44, 47, 48];
const BARCODE_CLEAR_LENGTHS = 33;
export function useBarCode() {
    const { t } = useTranslation();
    const [barcode, setBarcode] = useState();
    const [isBarcodeValid, setIsBarcodeValid] = useState();
    const [barcodeMessage, setBarcodeMessage] = useState();
    function removeBarcodeFormat(value) {
        if (!value)
            return undefined;
        return value.replace(/\D/g, '');
    }
    function validateBarcode(value) {
        if (!value)
            return false;
        const digitsOnly = value.replace(/\D/g, '');
        return BARCODE_VALID_LENGTHS.includes(digitsOnly.length);
    }
    function updateBarcode(nextValue) {
        if (nextValue === undefined) {
            setIsBarcodeValid(false);
            setBarcodeMessage(undefined);
            setBarcode(undefined);
            return;
        }
        const digitsOnly = nextValue.replace(/\D/g, '');
        const shouldPreserveFormat = digitsOnly.length > BARCODE_CLEAR_LENGTHS;
        setBarcode(shouldPreserveFormat ? nextValue : digitsOnly);
        const isValid = validateBarcode(nextValue);
        setIsBarcodeValid(isValid);
        setBarcodeMessage(undefined);
        if (!isValid) {
            setBarcodeMessage(t('invalid-code-billet-not-found-error'));
        }
    }
    return {
        barcode,
        isBarcodeValid,
        barcodeMessage,
        validateBarcode,
        setBarcodeMessage,
        updateBarcode,
        removeBarcodeFormat,
    };
}
